import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b3a01da"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid-item" }
const _hoisted_2 = { class: "grid-item-head" }
const _hoisted_3 = { class: "grid-item-head-index" }
const _hoisted_4 = { class: "grid-item-head-title" }
const _hoisted_5 = { class: "update-time" }
const _hoisted_6 = { class: "update-time-inner" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "更新時刻", -1))
const _hoisted_8 = { class: "grid-item-body" }
const _hoisted_9 = { class: "gird-item-body-row" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "水位天端", -1))
const _hoisted_11 = { class: "value-wrap" }
const _hoisted_12 = { class: "value" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "unit" }, "m", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_15 = { class: "gird-item-body-row" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "水位AP", -1))
const _hoisted_17 = { class: "value-wrap" }
const _hoisted_18 = { class: "value" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "unit" }, "m", -1))

import { computed } from 'vue'

type WaterPanelUIProps = {
  no: number
  stationName: string
  updatedAt: string
  leveeCrown: string
  ap: string
  diff: number
}


export default /*#__PURE__*/_defineComponent({
  props: {
    no: null,
    stationName: null,
    updatedAt: null,
    leveeCrown: null,
    ap: null,
    diff: null
  },
  setup(__props: any) {

const props = __props as {
  no: number
  stationName: string
  updatedAt: string
  leveeCrown: string
  ap: string
  diff: number
}



const arrowStyle = computed(() => {
  const deg = props.diff > 0 ? -45 : props.diff < 0 ? 45 : 0

  return {
    transform: `rotate(${deg}deg)`,
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(props.no), 1),
      _createElementVNode("span", _hoisted_4, _toDisplayString(props.stationName), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("p", null, _toDisplayString(props.updatedAt), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("span", _hoisted_12, _toDisplayString(props.leveeCrown), 1),
          _hoisted_13
        ])
      ]),
      _hoisted_14,
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("span", _hoisted_18, "AP+ " + _toDisplayString(props.ap), 1),
          _hoisted_19,
          _createElementVNode("span", {
            style: _normalizeStyle(_unref(arrowStyle)),
            class: "arrow"
          }, null, 4)
        ])
      ])
    ])
  ]))
}
}

})